import { render, staticRenderFns } from "./letter.vue?vue&type=template&id=1b584de4&scoped=true&"
var script = {}
import style0 from "./letter.vue?vue&type=style&index=0&id=1b584de4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b584de4",
  null
  
)

export default component.exports